<template>
  

  <div class="grid">
    <loading
    :active="isLoadingModel"
    :can-cancel="true"
    color="#173EA3"
    :is-full-page="fullPage"
  ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />

        <Toast />

          <div class="grid p-fluid mt-3" style="margin-top: 2%;">
 
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Calendar
                  v-model="from_date"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :showTime="false"
                  hourFormat="12"
                /><label >From Date</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Calendar
                  v-model="to_date"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :showTime="false"
                  
                  hourFormat="12"
                /><label >To Date</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText maxlength="10"  format="text" v-model="search_mobile" onkeypress="return event.charCode >= 48 && event.charCode <= 57"></InputText>              
                <label for="mobile_no">Mobile No.</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <Dropdown id="state" filter v-model="ride_status" :options="ride_status_dropdown" optionLabel="name" :optionValue="name"></Dropdown>
              <label for="Status">Status</label>
              </span>
            </div>
 
            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText type="text" v-model="search_name" onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode == 32)" />
                  <label for="mobile_no">Name</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText type="text" v-model="search_city" onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode == 32) || (event.charCode == 45)" />
                  <label for="mobile_no">City</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText type="text" v-model="search_state" onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)" />
                <label for="mobile_no">State</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText maxlength="6" type="text" v-model="search_pincode" onkeypress="return event.charCode >= 48 && event.charCode <= 57"/>
                  <label for="mobile_no">Pincode</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText maxlength="15" type="text" v-model="vehicle_registrationNumber " onkeypress="return event.charCode>=32 && event.charCode<=90 " /><label for="vehicle_no">Vehicle Number</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="user_key && (client_group_ids)">
                <span class="p-float-label">
                  <MultiSelect v-if="user_key && (client_group_ids)" id="state" filter  v-model="client_id_search"  style="width:180px" :options="client_id_dropdown" optionLabel="name" :optionValue="value" @change="route_list"></MultiSelect>
                <!-- {{client_id_search}} -->
                <label for="client">Select Client</label>
              </span>
              </div>&nbsp;

            <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown        
                      id="status" filter
                      v-model="routeitem"
                      :options="routeitems"
                      :value="routeitems.value"
                      optionLabel="name"
                     
                      required="true"
                      
                  ></Dropdown>
                    <label for="client">Select Route</label>
                </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Button v-if="!showFirstFilter" style="color: white; background: 
        lightgreen; border: none" icon="pi pi-ellipsis-h" @click="show_filter()"  v-tooltip.bottom="'more'" />&nbsp;
                <Button  icon="pi pi-search" @click="search(1)"   v-tooltip.bottom="'Search'"/>&nbsp; 
                 <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
                
              </span>
              
            </div>
          </div>
          
       
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true" showGridlines
        >
        <template #empty>
        <b style="text-align:center">No records found.</b>
      </template>
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0"><b> Manage Rides</b></h5>
              <!-- Total Records:{{totalRecords}} -->
              
              <!-- <Button icon="pi pi-refresh" @click="search(2)"   v-tooltip.bottom="'Reset'"/> -->
             
              <!-- <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Search..." />
                            </span> -->
            </div><div style="text-align:right;font-weight:bold"><span>Total Rides:</span>{{totalRecords}}</div>
       
            
            <!-- <div
              class="
                flex flex-column
                md:flex-row  
              "
            >
                <div style="padding-right:10px">From Date</div><div style="padding-right:10px"><Calendar
                  v-model="from_date"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :showTime="false"
                  style="height:20px"
                  hourFormat="12"
                /></div> <div style="padding-right:10px">To Date</div><div style="padding-right:10px"><Calendar
                  v-model="to_date"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :showTime="false"
                  style="height:20px"
                  hourFormat="12"
                /></div><div style="padding-right:10px">Mobile Number</div><div style="padding-right:10px"><input type="text"  v-model="search_mobile"></div>
                <div style="padding-right:10px;width:40px">Status</div><div style="padding-right:10px"><select style="width:100px;height:20px" v-model="ride_status"><option value="">Select Status</option><option value="Active">Active</option><option value="Complete">Completed</option></select></div>
                       <div style="padding-right:10px">   <Button style="height:20px" icon="pi pi-search" @click="search()" /></div>

            </div> -->
          </template>

          <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> -->
          <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->

          <Column header="Status" style="min-width: 8rem ;text-align: center;" :field="columns[14]" >
            <template #body="{ data }">
              <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
              <span v-else-if="data.status=='InActive' ||data.status=='In active'"><badge :value=data.status severity="warning"></badge></span>
              <span v-else-if="data.status=='Deleted' ||data.status=='deleted'"><badge :value=data.status severity="danger"></badge></span>
            
            <span v-else ><badge :value=data.status severity="primary"></badge></span>
            </template>
          </Column>

          <Column header="Sr No" style="min-width: 5rem;text-align: center;">
            <template #body="{ index}">
            <span v-if="page_no==1">{{ +index+ +1 }}</span>
              <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
            </template>
          </Column>
           
          <Column header="Date" :field="columns[9]" style="text-align:left;width:100px">
            <template #body="{ data }">
              {{ data.datedmy }}
            </template>
          </Column>
          <Column
            header="Vehicle No."
            style="min-width: 10rem"
            >
            <template #body="{ data }">
              {{ data.vehicle_registrationNumber }}
            </template>
          </Column>
          
          <!-- <Column header="Commuter Number" :field="columns[3]" style="min-width: 5rem">
            <template #body="{ data }">
              <p v-if="data.userDetails">{{ data.userDetails.mobile_number }}</p>
            </template>
          </Column> -->
          <Column header="Driver Name" :field="columns[4]" style="min-width: 10rem">
            <template #body="{ data }">
              <p v-if="data.driverdetails"> {{ data.driverdetails.first_name }} {{ data.driverdetails.last_name }}</p>
            </template>
          </Column>
          <Column header="Driver Mobile" :field="columns[4]">
            <template #body="{ data }">
                <p v-if="data.driverdetails"> {{ data.driverdetails.mobile_number }}</p>            </template>
          </Column>
          <Column header="Route Name" :field="columns[4]" style="min-width: 10rem">
            <template #body="{ data }">
                <p> {{ data.group_name }}</p>            </template>
          </Column>
          <Column header="Total Stops" :field="columns[5]" style="min-width: 5rem">
            <template #body="{ data }">
                <p> {{ data.group_stops.length }}</p>            </template>
          </Column>
          <Column header="Total Scans" :field="columns[5]" style="min-width: 5rem">
            <template #body="{ data }">
                <p> {{ data.ride_user_scans_total }}</p>            </template>
          </Column>
          <!-- <Column header="From" :field="columns[6]">
            <template #body="{ data }">
                 {{ data.from_destination }}   
                 
            </template>
          </Column>
          <Column header="Distance" :field="columns[12]" style="text-align:right;">
            <template #body="{ data }">
              {{ data.distance }}
            </template>
          </Column>
          <Column header="Total Time" :field="columns[9]" style="text-align:right;">
            <template #body="{ data }">
              {{ data.total_time/60 }}
            </template>
          </Column> -->
          <!-- <Column header="Customer Feedback" :field="columns[10]">
            <template #body="{ data }">
              {{ dateFormat(data.customer_feedback) }}
            </template>
          </Column> -->
          
          <Column header="Action" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-eye"
                class="p-button-small p-button-rounded p-button-primary mr-2"
                @click="view_ride_details(slotProps.data)"
                size="small"
              />
              <!-- <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
              /> -->
            </template>
          </Column>
        </DataTable>

        <Sidebar
          v-model:visible="productDialog"
          :baseZIndex="1000"
          position="full"
        >
          <div class="col-12">
            <div class="card">
              <h5>User Form</h5>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-2">
                  <label for="status">Status</label>
                  <Dropdown
                    id="status"
                    v-model="selectstatus"
                    :options="dropdownItems"
                    :value="dropdownItems.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"
                  ></Dropdown>
                </div>

                <div class="field col-12 md:col-2">
                  <label for="firsT_NAME">First Name</label>
                  <InputText
                    id="firsT_NAME"
                    type="text"
                    v-model.trim="product.firsT_NAME"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.firsT_NAME }"
                  />
                </div>

                <div class="field col-12 md:col-2">
                  <label for="middeL_NAME">Middle Name</label>
                  <InputText
                    id="middeL_NAME"
                    type="text"
                    v-model.trim="product.middeL_NAME"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.middeL_NAME }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="surname">Lastname</label>

                  <InputText
                    id="surname"
                    type="text"
                    v-model.trim="product.surname"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.surname }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="aadhaR_CARD">Adhar No</label>
                  <InputText
                    id="aadhaR_CARD"
                    type="number"
                    v-model.trim="product.aadhaR_CARD"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.aadhaR_CARD }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="state">State</label>
                  <InputText
                    id="state"
                    type="text"
                    v-model.trim="product.state"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.state }"
                  />
                </div>

                <div class="field col-12 md:col-2">
                  <label for="disrtict">District</label>
                  <InputText
                    id="disrtict"
                    type="text"
                    v-model.trim="product.disrtict"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.disrtict }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="taluka">Taluka</label>
                  <InputText
                    id="taluka"
                    type="text"
                    v-model.trim="product.taluka"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.taluka }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="citY_VILLAGE">City/Village</label>
                  <InputText
                    id="citY_VILLAGE"
                    type="text"
                    v-model.trim="product.citY_VILLAGE"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.citY_VILLAGE }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="pincode">Pincode</label>
                  <InputText
                    id="pincode"
                    type="number"
                    v-model.trim="product.pincode"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.pincode }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-12">
                  <label for="address">Address</label>

                  <Textarea
                    id="address"
                    type="text"
                    v-model.trim="product.address"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.address }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="mobile">Mobile No</label>
                  <InputText
                    id="mobile"
                    type="number"
                    v-model.trim="product.mobile"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && !product.mobile,
                    }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="email">Email</label>
                  <InputText
                    id="email"
                    type="text"
                    v-model.trim="product.email"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.email }"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6">
            <Button
              v-if="product.admiN_ID"
              label="UPDATE"
              icon="pi pi-check"
              class="p-button-success mr-1 mb-1"
              @click="adduser"
            />
            <Button
              v-else
              label="ADD"
              icon="pi pi-check"
              class="p-button-success mr-1 mb-1"
              @click="adduser"
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger mr-1 mb-1"
              @click="visibleFull = false"
            />
          </div>
        </Sidebar>

        <Dialog
          v-model:visible="productDialog_old"
          :style="{ width: '450px', width: '450px' }"
          header="Year Details"
          :modal="true"
          class="p-fluid"
        >
          <div class="grid">
            <div class="col-12 md:col-12">
              <div class="field">
                <!-- <img
            :src="'images/product/shoes.jpg'"
            :alt="product.image"
            width="150"
            class="mt-0 mx-auto mb-5 block shadow-2"
          /> -->
              </div>
              <div class="field">
                <label for="enrollmenT_YEAR"
                  >Enrollement Year <i style="color: green">(eg.2022)</i></label
                >
                <InputText
                  id="enrollmenT_YEAR"
                  v-model.trim="product.enrollmenT_YEAR"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !product.enrollmenT_YEAR,
                  }"
                />
              </div>
              <div class="field">
                <label for="exaM_YEAR"
                  >Exam Year <i style="color: green">(eg.2022-23)</i></label
                >
                <InputText
                  id="exaM_YEAR"
                  v-model.trim="product.exaM_YEAR"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.exaM_YEAR }"
                />
                <!-- <small class="p-invalid" v-if="submitted && !product.name"
                  >Name is required.</small
                > -->
              </div>
              <!-- <div class="field">
                <label for="description">Description</label>
                <Textarea
                  id="description"
                  v-model.trim="product.description"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.description }"
                />
              </div>
              <div class="field">
                <label for="link">Video Link</label>
                <InputText
                  id="link"
                  v-model.trim="product.videolink"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.link }"
                />
              </div>
              
              <div class="field">
                <label for="status">Type</label>

                <Dropdown
                  id="state"
                  v-model="selectstatus"
                  :options="dropdownItems"
                  :value="dropdownItems.value"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus }"
                  required="true"
                ></Dropdown>
              </div>

              <div class="field">
                <label for="status">Status</label>

                <Dropdown
                  id="state"
                  v-model="selectstatus2"
                  :options="dropdownItems2"
                  :value="dropdownItems2.value"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus2 }"
                  required="true"
                ></Dropdown>
              </div> -->
            </div>
            <div class="col-12 md:col-6">
              <!-- <Button
                v-if="product.mjyeaR_ID"
                label="UPDATE"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="Addyear"
               
              />
              <Button
                v-else
                label="ADD"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="Addyear"
              /> -->
            </div>
            <div class="col-12 md:col-6">
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-danger mr-1 mb-1"
                @click="productDialog = false"
              />
            </div>
          </div>
        </Dialog>

        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete <b>{{ product.firsT_NAME }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteuser"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import BreadcrumbService from "../service/BreadcrumbService";

import JsonExcel from "vue-json-excel";

//import FormNewsMaster from "@/components/FormNewsMaster";


// import axios from "axios";
import apis from "@/apis";
import axios from "axios";

export default {
  data() {
    return {
      client_group_ids:'',
      user_key:"",
      client_id_dropdown: [],
      client_id_search:'',

      routeitem:'',
      routeitems:[],

      page_no:1,
      isLoading: false,
      search_mobile:'',
      search_name:'',
      search_city:'',
      search_state:'',
      search_pincode:'',
      vehicle_registrationNumber:'',
      from_date:'',
      to_date:'',
      showFirstFilter: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      // dropdownItems: [
      //   { name: "Motivational", value: "Motivational" },
      //   { name: "Interview", value: "Interview" },
      // ],
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: { name: "", value: "" },
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      ride_status:'',
      // ride_status_dropdown: [{ name: "Read", value: "1" },
      //                        {name: "UnRead", value: "0"},
                             
      //                       ],
      ride_status_dropdown: [{ name: "Complete", value: "Complete" },
                             {name: "Active", value: "Active"},
                             {name: "InActive", value: "InActive"}],
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService : null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.get_client_list();
    this.route_list();
    this.user_key=localStorage.getItem("user_key");
    this.client_group_ids=localStorage.getItem('client_group_ids');

    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.ridemaster()
    this.breadcrumbHome=Breadcrum_data.home;
    this.breadcrumbItems=Breadcrum_data.items;
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    show_filter() {
      this.showFirstFilter = true;
    },
   async view_ride_details(data)
    {
      await localStorage.setItem('ridedetails',JSON.stringify(data));
      // console.log(data);
      // return;

      this.$router.push({name:"RideDetails"});
    },
    reset()
    {
      this.from_date="";
            this.to_date="";
            this.search_mobile="";
            this.search_name="";
            this.search_city="";
            this.showFirstFilter = false;
            this.search_state="";
            this.search_pincode="";
            this.vehicle_registrationNumber="";          
          
            this.ride_status="";
            this.client_id_search="";
            this.routeitem="";
            this.get_list();
        this.get_count();
    },
    search(count)
      { 
        if (count==2) 
        {
            this.from_date="";
            this.to_date="";
            this.search_mobile="";
            this.showFirstFilter = false;
            this.search_name="";
            this.search_city="";
            this.search_state="";
            this.search_pincode="";
            this.vehicle_registrationNumber="";          
          
            this.ride_status="";
            this.client_id_search="";
            this.routeitem="";
          

        }
        // this.page_no=1;
        this.get_list();
        this.get_count();
    },
        // if(this.search_mobile!='' && this.search_mobile.length!=10)
        // {
        //   this.$toast.add({
        //   severity: "error",
        //   summary: "error",
        //   detail: "Please Enter Valid Mobile Number",
        //   life: 3000,
        // });
        // return false;
        // }

        // if(this.search_pincode!='' && this.search_pincode.length<6)
        // {
        //   this.$toast.add({
        //   severity: "error",
        //   summary: "error",
        //   detail: "Please Enter 6 digit Pincode",
        //   life: 3000,
        // });
        // return false;
        // }

        // const vehicle_regex = new RegExp(/^[A-Z]{2}[ -][0-9]{1,2}[ -][A-Z]{1,2}[ -][0-9]{3,4}$/);
        // if(this.vehicle_registrationNumber!='' && !vehicle_regex.test(this.vehicle_registrationNumber))
        // {
        //   this.$toast.add({
        //   severity: "error",
        //   summary: "error",
        //   detail: "Please Enter valid Vehicle Number",
        //   life: 3000,
        // });
        // return false;
        // }

      
    //a simple date formatting function
    dateFormat(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return date+"-"+month+"-"+year;
                }
            }
        }
        else {
           return "";
        }
    },
    dateFormatYMD(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return year+"-"+month+"-"+date;
                }
            }
        }
        else {
           return "";
        }
    },
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];

      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
    //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    route_list()
    {     this.routeitems=[];
    // alert(this.client_id_search.value);
    var client_group_ids = []
              
    if (this.client_id_search && this.client_id_search.length>0) 
        {
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
      var client_id=localStorage.getItem("client_id");
      var data = {
          
          count: false,
          client_id: client_id,
          user_id:localStorage.getItem("id"),
          client_group_ids:client_group_ids
        };
        this.loading = true;
        var promise = apis.group_list(data, this.id);
        promise.then((response) => {
          this.loading = false;
          if (response.data.data.length > 0) {
            
          response.data.data
            .filter(item => item.name)
            .map(item => this.routeitems.push({ name: item.name, value: item._id }));
         
          }
        });
    },
    get_client_list()
    {  const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];

      var data = { count: false};
      var promise = apis.getclientist(data);
        promise.then((response) => {
          // if(response.data.data){
          // response.data.data
          //   .filter(item => item.client_name)
          //   .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
          // }
          var temp_data = [];

                    for (let x = 0; x < response.data.data.length; x++) {
                        const clientData = response.data.data[x];
                        
                        if (clientData.client_name && (client_group_ids.length === 0 || client_group_ids.includes(clientData._id))) {
                            temp_data.push({ name: clientData.client_name, value: clientData._id });
                        }
                    }

                    this.client_id_dropdown = temp_data;
        });
    },
    get_count: function () {
      var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
      //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      if (this.client_id_search && this.client_id_search.length>0) 
        {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
      var data = {
        id: localStorage.getItem("id"),
        count: true,
        mobile_number:this.search_mobile,
        status:this.ride_status.value,
        from_date:this.dateFormatYMD(this.from_date),
        to_date:this.dateFormatYMD(this.to_date),
        client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
        user_id:localStorage.getItem("id"),
        name:this.search_name,
        city:this.search_city,
        Region:this.search_state,
        pincode:this.search_pincode,
        vehicle_number:this.vehicle_registrationNumber,
        group_id:this.routeitem.value,
        "client_group_ids":client_group_ids,
      };
      this.loading = true;
      var promise = apis.rideMaster(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });

      console.log(data);
    },
    get_list: function () {
      var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
      //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      if (this.client_id_search && this.client_id_search.length>0) 
        {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        status:this.ride_status.value,
        mobile_number:this.search_mobile,
        from_date:this.dateFormatYMD(this.from_date),
        to_date:this.dateFormatYMD(this.to_date),
        client_id:localStorage.getItem("client_id"),
        "client_group_ids":client_group_ids,
        user_id:localStorage.getItem("id"),
        name:this.search_name,
        city:this.search_city,
        Region:this.search_state,
        pincode:this.search_pincode,
        vehicle_number:this.vehicle_registrationNumber,
        group_id:this.routeitem.value
      };
      this.loading = true;
      var promise = apis.rideMaster(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });

      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async adduser() {
      this.submitted = true;
      if (!this.selectstatus.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.product.firsT_NAME) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter First Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.middeL_NAME) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Middle Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.surname) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter LastName",
          life: 3000,
        });
        return false;
      }
       if (!this.product.aadhaR_CARD) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Adhar No",
          life: 3000,
        });
        return false;
      }
      
      if (!this.product.state) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter State",
          life: 3000,
        });
        return false;
      }
      if (!this.product.disrtict) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter District",
          life: 3000,
        });
        return false;
      }
       if (!this.product.taluka) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Taluka",
          life: 3000,
        });
        return false;
      }
      if (!this.product.citY_VILLAGE) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter city/village",
          life: 3000,
        });
        return false;
      }
      if (!this.product.pincode) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Pincode",
          life: 3000,
        });
        return false;
      }
      if (!this.product.address) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter address",
          life: 3000,
        });
        return false;
      }
      if (!this.product.mobile) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter mobile",
          life: 3000,
        });
        return false;
      }
      if (!this.product.email) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter email",
          life: 3000,
        });
        return false;
      }

      //edit
      if (this.product.admiN_ID) {
        var data = {
          Admin_id: this.product.admiN_ID,
          firsT_NAME: this.product.firsT_NAME,
          middeL_NAME: this.product.middeL_NAME,
          surname: this.product.surname,
          address: this.product.address,
          state: this.product.state,
          disrtict: this.product.disrtict,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: parseInt(this.product.mobile),
          email: this.product.email,
          pincode: parseInt(this.product.pincode),
          aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
          status: this.selectstatus.value,
          createD_BY: localStorage.getItem("full_name"),
          client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id")
        };
        this.isLoadingModel = true;
        var promise = apis.editusermaster(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          firsT_NAME: this.product.firsT_NAME,
          middeL_NAME: this.product.middeL_NAME,
          surname: this.product.surname,
          address: this.product.address,
          state: this.product.state,
          disrtict: this.product.disrtict,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: parseInt(this.product.mobile),
          email: this.product.email,
          pincode: parseInt(this.product.pincode),
          aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
          status: this.selectstatus.value,
          createD_BY: localStorage.getItem("full_name"),
          client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id")
        };
        this.isLoadingModel = true;
        var promises = apis.addusermaster(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }

      this.selectstatus = { name: "", value: "" };
      //  this.selectstatus2={name:"",value:""}
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.name.trim()) {
        if (this.product.id) {
          this.product.inventoryStatus = this.product.inventoryStatus.value
            ? this.product.inventoryStatus.value
            : this.product.inventoryStatus;
          this.products[this.findIndexById(this.product.id)] = this.product;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          this.product.id = this.createId();
          this.product.code = this.createId();
          this.product.image = "product-placeholder.svg";
          this.product.inventoryStatus = this.product.inventoryStatus
            ? this.product.inventoryStatus.value
            : "INSTOCK";
          this.products.push(this.product);
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        this.productDialog = false;
        this.product = {};
      }
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.selectstatus.value = this.product.status;
      this.selectstatus.name = this.product.status;

      // this.selectstatus2.value = this.product.status;
      // this.selectstatus2.name = this.product.status;

      // this.file_attachment = this.product.image;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },

    deleteuser() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
        };
        this.isLoadingModel = true;
        var promise = apis.deleteusermaster(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Video");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    
  async  exportCSV() {
      this.limit=this.totalRecords;
      this.get_list();
     await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {downloadExcel: JsonExcel},
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
